import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "chart-grid chart-grid-3" }
const _hoisted_2 = { class: "chart-card" }
const _hoisted_3 = {
  key: 0,
  class: "no-data"
}
const _hoisted_4 = {
  key: 1,
  class: "chart-body"
}
const _hoisted_5 = { class: "chart-card" }
const _hoisted_6 = {
  key: 0,
  class: "no-data"
}
const _hoisted_7 = {
  key: 1,
  class: "chart-body"
}
const _hoisted_8 = { class: "chart-card" }
const _hoisted_9 = {
  key: 0,
  class: "no-data"
}
const _hoisted_10 = {
  key: 1,
  class: "chart-body"
}
const _hoisted_11 = { class: "chart-grid chart-grid-3" }
const _hoisted_12 = { class: "chart-card" }
const _hoisted_13 = {
  key: 0,
  class: "no-data"
}
const _hoisted_14 = {
  key: 1,
  class: "chart-body"
}
const _hoisted_15 = { class: "chart-card" }
const _hoisted_16 = {
  key: 0,
  class: "no-data"
}
const _hoisted_17 = {
  key: 1,
  class: "chart-body"
}
const _hoisted_18 = { class: "chart-card" }
const _hoisted_19 = {
  key: 0,
  class: "no-data"
}
const _hoisted_20 = {
  key: 1,
  class: "chart-body"
}
const _hoisted_21 = { class: "chart-grid chart-grid-single" }
const _hoisted_22 = { class: "chart-card chart-card-wide" }
const _hoisted_23 = {
  key: 0,
  class: "no-data"
}
const _hoisted_24 = {
  key: 1,
  class: "chart-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "card-title" }, "Findings Status", -1)),
        (!_ctx.hasFindingsStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No Records Found"))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_apexchart, {
                type: "donut",
                height: "300",
                options: _ctx.findingsStatusOptions,
                series: _ctx.findingsStatusSeries
              }, null, 8, ["options", "series"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "card-title" }, "Findings by Team", -1)),
        (!_ctx.hasDepartmentData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "No Records Found"))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_apexchart, {
                type: "bar",
                height: "300",
                options: _ctx.departmentChartOptions,
                series: _ctx.departmentSeries
              }, null, 8, ["options", "series"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "card-title" }, "Findings by Location", -1)),
        (!_ctx.hasLocationData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "No Records Found"))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_apexchart, {
                type: "bar",
                height: "300",
                options: _ctx.locationChartOptions,
                series: _ctx.locationSeries
              }, null, 8, ["options", "series"])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "card-title" }, "CAPA Status", -1)),
        (!_ctx.hasCapaStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, "No Records Found"))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_apexchart, {
                type: "donut",
                height: "300",
                options: _ctx.capaStatusOptions,
                series: _ctx.capaStatusSeries
              }, null, 8, ["options", "series"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "card-title" }, "CAPA Status by Team", -1)),
        (!_ctx.hasCapaTeamData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, "No Records Found"))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_apexchart, {
                type: "bar",
                height: "300",
                options: _ctx.capaTeamChartOptions,
                series: _ctx.capaTeamSeries
              }, null, 8, ["options", "series"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "card-title" }, "CAPA Status by Location", -1)),
        (!_ctx.hasCapaLocationData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, "No Records Found"))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_apexchart, {
                type: "bar",
                height: "300",
                options: _ctx.capaLocationChartOptions,
                series: _ctx.capaLocationSeries
              }, null, 8, ["options", "series"])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "card-title" }, "CAPA Overdue by Team", -1)),
        (!_ctx.hasCapaOverdueData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, "No overdue CAPA tasks"))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createVNode(_component_apexchart, {
                type: "radar",
                height: "340",
                options: _ctx.capaOverdueChartOptions,
                series: _ctx.capaOverdueSeries
              }, null, 8, ["options", "series"])
            ]))
      ])
    ])
  ]))
}